import React from 'react';
import { Instagram, Facebook, Youtube, Home, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom'; // Importez Link pour la navigation interne

function Footer() {
  return (
    <div>
      <footer className="bg-gray-800 text-white py-4">
        <section className="container mx-auto">
          <div className="flex flex-wrap">
            {/* Première colonne */}
            <div className="w-full md:w-1/4 p-4">
              <h5 className="text-uppercase text-yellow-500 font-bold mb-4">PERSPECTIVE CONGO</h5>
              <p>
                Restons en contact, et pensons aussi au Congo.
              </p>
              <div className="flex gap-3">
                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                  <Instagram className="text-2xl hover:text-yellow-500 transition-colors" />
                </a>
                <a href="https://www.facebook.com/perspective.congo" target="_blank" rel="noopener noreferrer">
                  <Facebook className="text-2xl hover:text-yellow-500 transition-colors" />
                </a>
                <a href="https://www.youtube.com/channel/UChlYfxS0yWyWs0kaL_3ELRw" target="_blank" rel="noopener noreferrer">
                  <Youtube className="text-2xl hover:text-yellow-500 transition-colors" />
                </a>
              </div>
            </div>

            {/* Deuxième colonne */}
            <div className="w-full md:w-1/4 p-4">
              <h5 className="text-uppercase font-bold mb-4">Pages</h5>
              <ul className="list-none">
                <li>
                  <Link to="/" className="hover:text-yellow-500 transition-colors">Accueil</Link>
                </li>
                <li>
                  <Link to="/apropos" className="hover:text-yellow-500 transition-colors">A propos</Link>
                </li>
                <li>
                  <Link to="/evenement" className="hover:text-yellow-500 transition-colors">Événements</Link>
                </li>
                <li>
                  <Link to="/galerie" className="hover:text-yellow-500 transition-colors">Galerie</Link>
                </li>
              </ul>
            </div>

            {/* Troisième colonne */}
            <div className="w-full md:w-1/4 p-4">
              <h5 className="text-uppercase font-bold mb-4">Partenaires</h5>
              <ul className="list-none">
                <li>Association NSP</li>
                <li>Maison de l'Afrique</li>
                <li>AECF</li>
                <li>Ambassade du Congo</li>
                <li>PUZZLE association</li>
              </ul>
            </div>

            {/* Quatrième colonne */}
            <div className="w-full md:w-1/4 p-4">
              <h5 className="text-uppercase font-bold mb-4">Contacts</h5>
              <ul className="list-none">
                <li className="flex items-center">
                  <Home className="mr-2" /> France, Nantes
                </li>
                <li className="flex items-center">
                  <Phone className="mr-2" /> +33 6 65 32 87 71
                </li>
                <li className="flex items-center">
                  <Mail className="mr-2" /> contact@perspectivecongo.com
                </li>
              </ul>
            </div>
          </div>
        </section>
      </footer>
      <div className="text-center text-white py-4 bg-black">
        <p>&copy; 2025 Perspective Congo. Tous droits réservés.</p>
      </div>
    </div>
  );
}

export default Footer;